import PropTypes from 'prop-types';
import { Component } from 'react';

import makeTrackable from '../../../helpers/make-trackable';

class CheckboxFilter extends Component {
  static propTypes = {
    slug: PropTypes.string.isRequired,
    checked: PropTypes.bool.isRequired,
    onChange: PropTypes.func.isRequired,
    label: PropTypes.string.isRequired,
    disabled: PropTypes.bool,
    focusRef: PropTypes.object,
  };

  render() {
    const { slug, checked, onChange, label, focusRef, disabled = false } = this.props;

    return (
      <li>
        <label className={`boolean optional ${disabled ? 'disabled' : ''}`}>
          <input
            className={`boolean optional ${disabled ? 'disabled' : ''}`}
            type="checkbox"
            name="category"
            checked={checked}
            data-track="filter"
            onChange={() => onChange(slug, checked)}
            disabled={disabled}
            ref={focusRef}
          />
          <span>{label}</span>
          <span className="check" />
        </label>
      </li>
    );
  }
}

const TrackableCheckboxFilter = makeTrackable(CheckboxFilter, { domNodeName: 'input' });

export default TrackableCheckboxFilter;
